import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { init as jsBridgeInit } from '@haidilao-private/jsbridge';
import Vconsole from 'vconsole';
// import pathConfig from '@/utils/pathConfig';
jsBridgeInit();

// 非线上环境添加vconsole
if (
  process.env.REACT_APP_API_ENV === 'qa'
) {
  new Vconsole();
}

const root = document.getElementById('root') as HTMLElement;
ReactDOM.createRoot(root).render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

